export default __webpack_public_path__ + "static/media/Brightness.e6e8fe20.svg";